var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusBgPrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 1.5C6.425 1.5 1.5 6.425 1.5 12.5C1.5 18.575 6.425 23.5 12.5 23.5C18.575 23.5 23.5 18.575 23.5 12.5C23.5 6.425 18.575 1.5 12.5 1.5ZM13.5 16.5C13.5 16.7652 13.3946 17.0196 13.2071 17.2071C13.0196 17.3946 12.7652 17.5 12.5 17.5C12.2348 17.5 11.9804 17.3946 11.7929 17.2071C11.6054 17.0196 11.5 16.7652 11.5 16.5V13.5H8.5C8.23478 13.5 7.98043 13.3946 7.79289 13.2071C7.60536 13.0196 7.5 12.7652 7.5 12.5C7.5 12.2348 7.60536 11.9804 7.79289 11.7929C7.98043 11.6054 8.23478 11.5 8.5 11.5H11.5V8.5C11.5 8.23478 11.6054 7.98043 11.7929 7.79289C11.9804 7.60536 12.2348 7.5 12.5 7.5C12.7652 7.5 13.0196 7.60536 13.2071 7.79289C13.3946 7.98043 13.5 8.23478 13.5 8.5V11.5H16.5C16.7652 11.5 17.0196 11.6054 17.2071 11.7929C17.3946 11.9804 17.5 12.2348 17.5 12.5C17.5 12.7652 17.3946 13.0196 17.2071 13.2071C17.0196 13.3946 16.7652 13.5 16.5 13.5H13.5V16.5Z",
    fill: "#1C454E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusBgPrimary);
export default __webpack_public_path__ + "static/media/plus-bg-primary.930aac7ec5d61e64079f199a3b50641e.svg";
export { ForwardRef as ReactComponent };